<template>
    <Alert class="CriteriaDangerMessage" type="danger" rounded>
        <EidIcon
            class="CriteriaDangerMessage__icon"
            alt="icon"
            :icon-src="icon"
            :svg-props="{color: alertRedColor}"
        />
        <slot />
    </Alert>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

    import Alert from '@evidentid/dashboard-commons/components/Alert/Alert.vue';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import { tailwindColors as colors } from '@/styles/variables/tailwind-colors/tailwindColors';

    export default defineComponent({
        name: 'CriteriaDangerMessage',
        components: {
            Alert,
            EidIcon,
        },
        data() {
            return {
                alertRedColor: colors.eidDangerRed.DEFAULT,
                icon: faExclamationTriangle,
            };
        },
    });
</script>
